import { render } from "./RefundModal.vue?vue&type=template&id=7f06face"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__